import React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

interface SubjectTreeItemIconProps {
  open: boolean;
  loading?: boolean;
}

const SubjectTreeItemIcon = (props: SubjectTreeItemIconProps) => {
  const { open, loading } = props;

  if (loading) {
    return (
      <Box display="flex" alignItems="center">
        <CircularProgress size={22} />
      </Box>
    );
  }

  if (open) {
    return <FolderOpenIcon />;
  }

  return <FolderIcon />;
};

export default SubjectTreeItemIcon;
